import { asyncLoad } from '@util'
import React from 'react'
import JiaMengHeader from '@components/JiaMeng/Header/Setting'

const AsyncEditStore = asyncLoad(() =>
  import('@components/LocalMerchant/EditStore')
)

const AsyncEditAccount = asyncLoad(() =>
  import('@components/LocalMerchant/WalletBindCard/EditAccount')
)

const AsyncComponyChoose = asyncLoad(() =>
  import('@components/LocalMerchant/WalletBindCard/ComponyChoose')
)

const AsyncBindAuth = asyncLoad(() =>
  import('@components/LocalMerchant/WalletBindCard/BindAuth')
)
const AsyncAccountReview = asyncLoad(() =>
  import('@components/LocalMerchant/WalletBindCard/AccountReview')
)

const AsyncRealnameAuthentication = asyncLoad(() =>
  import('@components/Store/RealnameAuthentication')
)

export default [
  {
    path: 'editStore',
    component: AsyncEditStore,
    stat: '店铺信息/首页'
  },
  {
    path: 'realnameAuthentication',
    component: AsyncRealnameAuthentication,
    stat: '实名认证/首页'
  },
  {
    path: 'sellerService',
    component: props => <JiaMengHeader key="sellerService" {...props} />,
    indexRoute: {
      component: asyncLoad(() =>
        import('@components/Store/AccountManage/SellerService')
      )
    },
    stat: '绑定微信号'
  },
  {
    path: 'settlementAccount',
    component: props => <JiaMengHeader key="settlementAccount" {...props} />,
    indexRoute: {
      component: asyncLoad(() =>
        import('@components/Store/AccountManage/SettlementAccount')
      )
    },
    childRoutes: [
      {
        path: 'editAccount',
        component: AsyncEditAccount,
        stat: '账号管理/修改结算账户'
      },
      {
        path: 'bindAuth',
        component: AsyncBindAuth,
        stat: '账号管理/绑卡鉴权'
      },
      {
        path: 'accountReview',
        component: AsyncAccountReview,
        stat: '账号管理/审核详情'
      },
      {
        path: 'componyChoose',
        component: AsyncComponyChoose,
        stat: '账号管理/修改结算账户'
      }
    ],
    stat: '结算账户'
  }
]
